import React from 'react';
import HFHJSection8a from '../../../../../components/course/churchschool/hfhj/HFHJSection8a';
import JepsplSection from '../../../../../components/course/churchschool/JepsplSection';
import WarningSection from '../../../../../components/course/churchschool/WarningSection';
import HFHJSection14 from '../../../../../components/course/churchschool/hfhj/HFHJSection14';
import GodDealWeekSectionOct, {
  IS_DISPLAY_GODDEAL_SECTION,
} from '../../../../../components/course/churchschool/event/GodDealWeekSectionOct';

const BoostupHFBookMain = () => {
  return (
    <>
      {IS_DISPLAY_GODDEAL_SECTION && <GodDealWeekSectionOct />}

      <HFHJSection8a />
      <WarningSection />
      <JepsplSection />
      <HFHJSection14 />
    </>
  );
};

export default BoostupHFBookMain;
